import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { SimpleLayoutComponent } from '../simple-layout/simple-layout.component';
import { RouterModule } from '@angular/router';
import { ReactiveFormsModule } from '@angular/forms';
import { SidebarComponent } from './components/sidebar/sidebar.component';
import { NavbarComponent } from './components/navbar/navbar.component';
import { NbContactComponent } from './components/navbar/nb-contact/nb-contact.component';
import { DialogModule } from 'primeng/dialog';
import { ButtonModule } from 'primeng/button';

@NgModule({
  declarations: [
    SimpleLayoutComponent,
    SidebarComponent,
    NavbarComponent,
    NbContactComponent,
  ],
  imports: [
    CommonModule,
    RouterModule,
    ReactiveFormsModule,
    DialogModule,
    ButtonModule

  ],
  exports: [
    SimpleLayoutComponent,
    SidebarComponent,
    NavbarComponent
  ]
})
export class SimpleLayoutModule { }
